import React, { createContext, useState } from "react";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";
import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";

export const testSummaryReportContext = createContext(null);

const TestSummaryReportPage = () => {
  const [introduction, setIntroduction] = useState({});
  const [scope, setScope] = useState({});
  const [sprintDetails, setSprintDetails] = useState({});
  const [testCoverage, setTestCoverage] = useState({});
  const [defectDistribution, setDefectDistribution] = useState({});
  const [defectDetails, setDefectDetails] = useState({});
  const [references, setReferences] = useState({});
  const breadCrumbs = [
    {
      title: "Introduction",
      status:
        Object.entries(introduction).length > 0 ? "Completed" : "In Progress",
    },

    {
      title: "Scope",
      status:
        Object.entries(scope).length > 0
          ? "Completed"
          : Object.entries(introduction).length > 0
          ? "In Progress"
          : "Not Started",
    },

    {
      title: "Sprint Details",
      status:
        Object.entries(sprintDetails).length > 0
          ? "Completed"
          : Object.entries(scope).length > 0
          ? "In Progress"
          : "Not Started",
    },

    {
      title: "Test Coverage",
      status:
        Object.entries(testCoverage).length > 0
          ? "Completed"
          : Object.entries(sprintDetails).length > 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Defect Distribution",
      status:
        Object.entries(defectDistribution).length > 0
          ? "Completed"
          : Object.entries(testCoverage).length > 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Defect Details",
      status:
        Object.entries(defectDetails).length > 0
          ? "Completed"
          : Object.entries(defectDistribution).length > 0
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "References",
      status:
        Object.entries(references).length > 0
          ? "Completed"
          : Object.entries(defectDetails).length > 0
          ? "In Progress"
          : "Not Started",
    },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{ height: "56px" }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            minHeight: "80vh",
            height: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Container>
            <testSummaryReportContext.Provider
              value={{
                introduction,
                setIntroduction,
                scope,
                setScope,
                sprintDetails,
                setSprintDetails,
                testCoverage,
                setTestCoverage,
                defectDistribution,
                setDefectDistribution,
                defectDetails,
                setDefectDetails,
                references,
                setReferences,
              }}
            >
              <Outlet />
            </testSummaryReportContext.Provider>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default TestSummaryReportPage;
